import {
  Box, Card, CardContent, Typography,
} from '@mui/material';
import React from 'react';
import { style } from './style';

type SystemStatisticsCardItemProps = {
  icon: JSX.Element,
  amount: string,
  title: string,
  color: string,
}

export const SystemStatisticsCardItem = ({
  icon,
  amount,
  title,
  color,
}: SystemStatisticsCardItemProps):JSX.Element => {
  return (
    <Card sx={ style.Card.sx }>
      <CardContent sx={ style.CardContent.sx }>
        <Box sx={ { ...style.Box.color(color), ...style.Box.sx } }>
          <Box>{icon}</Box>
          <Box>{amount}</Box>
        </Box>
        <Typography variant="caption" sx={ style.Title.sx }>
          {title}
        </Typography>
      </CardContent>
    </Card>
  );
};
